import { apiGet } from "@/core/api";
export const apiLift20 = {
    getCitizenSummary: (citizenId) => apiGet(`citizens/${citizenId}/liftSummary`),
};
